export const ANALYSIS_MAP: Record<string, string> = {
  cuckoo: "Cuckoo",
  cape: "CAPE",
  fireeye: "FireEye",
  joe: "Joe"
};
